import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useDeferredValue, useEffect, useTransition } from "react";
import { useMemoizedFn } from "ahooks";
import { debounce, differenceWith } from "lodash-es";
import { useAppStore, usePaneCacheStore } from "../../store";
export var useScrollCache = function useScrollCache(containerRef) {
  var pathname = useAppStore(function (s) {
    return s.pathname;
  });
  var defPathname = useDeferredValue(pathname);
  var _useTransition = useTransition(),
    _useTransition2 = _slicedToArray(_useTransition, 2),
    startTransition = _useTransition2[1];
  var setScrollHistory = usePaneCacheStore(function (s) {
    return s.setScrollHistory;
  });
  var scrollHistory = usePaneCacheStore(function (s) {
    return s.scrollHistory;
  });
  var panes = useAppStore(function (s) {
    return s.panes;
  });
  var handleScroll = useMemoizedFn(debounce(function (e) {
    var dom = e.target;
    setScrollHistory([{
      pathname: pathname,
      value: dom.scrollTop
    }]);
  }, 100));
  useEffect(function () {
    var _containerRef$current;
    (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || _containerRef$current.addEventListener("scroll", handleScroll);
    return function () {
      var _containerRef$current2;
      (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 || _containerRef$current2.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(function () {
    var cacheKeys = Object.keys(scrollHistory);
    var willRemovedCaches = differenceWith(cacheKeys, panes, function (path, pane) {
      return pane.path === path;
    });
    setScrollHistory(willRemovedCaches.map(function (el) {
      return {
        pathname: el,
        value: 0
      };
    }), true);
  }, [panes]);
  useEffect(function () {
    startTransition(function () {
      if (containerRef.current) {
        containerRef.current.scrollTop = scrollHistory[pathname] || 0;
      }
    });
  }, [defPathname]);
};